import React from "react";
import FormattedAsset from "../Utility/FormattedAsset";
import { Link } from "react-router-dom";
import Translate from "react-translate-component";
import counterpart from "counterpart";
import utils from "common/utils";
import LinkToAccountById from "../Utility/LinkToAccountById";
import LinkToAssetById from "../Utility/LinkToAssetById";
import { ChainStore, ChainTypes as grapheneChainTypes } from "bitsharesjs"; // import account_constants from "chain/account_constants";

const {
  operations
} = grapheneChainTypes;
import PropTypes from "prop-types";
import opComponents from "./operations";
import TranslateWithLinks from "../Utility/TranslateWithLinks";
import { Icon as AntIcon } from "bitshares-ui-style-guide";

require("./operations.scss");

let ops = Object.keys(operations); // let listings = account_constants.account_listing;

export const TransactionIDAndExpiry = ({
  id,
  expiration,
  style,
  openJSONModal
}) => {
  const endDate = counterpart.localize(new Date(expiration), {
    format: "short"
  });
  return /*#__PURE__*/React.createElement("b", {
    style: style
  }, openJSONModal ? /*#__PURE__*/React.createElement("span", {
    className: "cursor-pointer",
    onClick: openJSONModal
  }, id, " ", /*#__PURE__*/React.createElement(AntIcon, {
    type: "file-search"
  }), " | ") : /*#__PURE__*/React.createElement("span", null, id, " | "), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
    content: "proposal.expires"
  }), ": ", endDate));
};
TransactionIDAndExpiry.propTypes = {
  openJSONModal: PropTypes.func
};
TransactionIDAndExpiry.defaultProps = {
  openJSONModal: null
};

class Row extends React.Component {
  constructor(props) {
    super(props);
    this.showDetails = this.showDetails.bind(this);
  }

  showDetails(e) {
    e.preventDefault();
    this.props.history.push(`/block/${this.props.block}`);
  }

  render() {
    let {
      id,
      fee,
      hideFee,
      hideExpiration,
      expiration
    } = this.props;
    fee.amount = parseInt(fee.amount, 10);
    return /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "5px 0",
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement("span", null, this.props.info, "\xA0", hideFee ? null : /*#__PURE__*/React.createElement("span", {
      className: "facolor-fee"
    }, "(", /*#__PURE__*/React.createElement(FormattedAsset, {
      amount: fee.amount,
      asset: fee.asset_id
    }), " ", "fee)")), !hideExpiration && this.props.expiration && /*#__PURE__*/React.createElement(TransactionIDAndExpiry, {
      id: id,
      expiration: expiration,
      style: {
        paddingTop: 5,
        fontSize: "0.85rem",
        paddingBottom: "0.5rem",
        display: "block"
      }
    }));
  }

}

class ProposedOperation extends React.Component {
  state = {
    label_color: "info"
  };
  static defaultProps = {
    op: [],
    current: "",
    block: null,
    hideDate: false,
    hideFee: false,
    hideOpLabel: false,
    csvExportMode: false,
    collapsed: true
  };
  static propTypes = {
    op: PropTypes.array.isRequired,
    current: PropTypes.string,
    block: PropTypes.number,
    hideDate: PropTypes.bool,
    hideFee: PropTypes.bool,
    csvExportMode: PropTypes.bool,
    collapsed: PropTypes.bool
  };

  linkToAccount(name_or_id) {
    if (!name_or_id) return /*#__PURE__*/React.createElement("span", null, "-");
    return utils.is_object_id(name_or_id) ? /*#__PURE__*/React.createElement(LinkToAccountById, {
      account: name_or_id
    }) : /*#__PURE__*/React.createElement(Link, {
      to: `/account/${name_or_id}/overview`
    }, name_or_id);
  }

  linkToAsset(symbol_or_id) {
    if (!symbol_or_id) return /*#__PURE__*/React.createElement("span", null, "-");
    return utils.is_object_id(symbol_or_id) ? /*#__PURE__*/React.createElement(LinkToAssetById, {
      asset: symbol_or_id
    }) : /*#__PURE__*/React.createElement(Link, {
      to: `/asset/${symbol_or_id}`
    }, symbol_or_id);
  }

  changeColor = newColor => {
    const {
      label_color
    } = this.state;

    if (label_color !== newColor) {
      this.setState({
        label_color: newColor
      });
    }
  }; // TODO: add scu

  render() {
    let {
      op,
      proposer,
      block,
      hideExpiration,
      index,
      csvExportMode
    } = this.props;
    const {
      label_color
    } = this.state;
    let line = null,
        column = null;
    column = opComponents(ops[op[0]], this.props, {
      fromComponent: "proposed_operation",
      linkToAccount: this.linkToAccount,
      linkToAsset: this.linkToAsset,
      changeColor: this.changeColor
    });

    if (!!proposer) {
      column = /*#__PURE__*/React.createElement("div", {
        className: "inline-block"
      }, index == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          paddingBottom: "0.5rem"
        }
      }, /*#__PURE__*/React.createElement(TranslateWithLinks, {
        string: "operation.proposal_create",
        keys: [{
          type: "account",
          value: proposer,
          arg: "account"
        }]
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: "0.5rem"
        }
      }, column));
    }

    if (csvExportMode) {
      const globalObject = ChainStore.getObject("2.0.0");
      const dynGlobalObject = ChainStore.getObject("2.1.0");
      const block_time = utils.calc_block_time(block, globalObject, dynGlobalObject);
      return /*#__PURE__*/React.createElement("div", {
        key: this.props.key
      }, /*#__PURE__*/React.createElement("div", null, block_time ? block_time.toLocaleString() : ""), /*#__PURE__*/React.createElement("div", null, ops[op[0]]), /*#__PURE__*/React.createElement("div", null, column), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedAsset, {
        amount: parseInt(op[1].fee.amount, 10),
        asset: op[1].fee.asset_id
      })));
    }

    line = column ? /*#__PURE__*/React.createElement(Row, {
      index: index,
      id: this.props.id,
      block: block,
      type: op[0],
      color: label_color,
      fee: op[1].fee,
      hideDate: this.props.hideDate,
      hideFee: this.props.hideFee,
      hideOpLabel: this.props.hideOpLabel,
      info: column,
      expiration: this.props.expiration,
      hideExpiration: hideExpiration
    }) : null;
    return line ? line : /*#__PURE__*/React.createElement("div", null);
  }

}

export default ProposedOperation;